import React from "react";
import { Input, FormGroup, Label, FormFeedback } from "reactstrap";

const Select = ({
  name,
  items,
  label,
  error,
  textProperty,
  valueProperty,
  noEmpty,
  bold,
  required,
  placeholder,
  ...rest
}) => {
  return (
    <FormGroup className={required ? "required" : ""}>
      {label && (
        <Label for={name} className={bold ? "font-weight-bold" : ""}>
          {label}
        </Label>
      )}
      <Input
        {...rest}
        type="select"
        id={name}
        name={name}
        invalid={error ? true : false}
        style={{
          height: "38px",
          padding: " 4px",
          width: "100%",
          border: "1px solid gray",
          borderRadius: "6px"
        }}
      >
        {!noEmpty && !placeholder && <option value="" />}
        {placeholder && <option hidden>{placeholder}</option>}
        {items.map((item) => (
          <option key={item[valueProperty]} value={item[valueProperty]}>
            {item[textProperty]}
          </option>
        ))}
      </Input>
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  );
};

Select.defaultProps = {
  textProperty: "name",
  valueProperty: "id",
};

export default Select;
